import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { t } from 'i18next';
import CrudBase from "src/components/CrudBase";
import InvoiceClientConfig from 'src/models/invoiceClientConfig';
import InvoiceClientConfigForm from './InvoiceClientConfigForm';

export function InvoiceClientConfigs() {
    return (
        <CrudBase<InvoiceClientConfig>
            resource="invoice-client-configs"
            indexColumns={['client_rfc', 'client_name', 'expeditor_rfc', 'expeditor_name']}
            showModalColumns={['note','font','font_size','font_size_title','created_at','updated_at']}
            permissions={{
                'view' : 'invoices.client_config',
                'list' : 'invoices.client_config',
                'create' : 'invoices.client_config',
                'edit' : 'invoices.client_config',
                'delete' : 'invoices.client_config',
            }}
            Form={InvoiceClientConfigForm}
            deleteButton={true}
            searchInput={true}
            Icon={ManageAccountsIcon} />
    );
}
